import { AlertContext } from 'client/contexts/alert/Alert';
import { useContext } from 'react';

export const useAlert = () => useContext(AlertContext);
